// src/components/PageTransition.js
import React from 'react';
import { useLocation } from 'react-router-dom';
import './PageTransition.css';

/**
 * Enveloppe chaque route pour une transition fluide.
 * Utilise la clé de la route pour déclencher l'animation à chaque changement.
 */
const PageTransition = ({ children }) => {
  const location = useLocation();

  return (
    <div className="page-transition" key={location.pathname}>
      {children}
    </div>
  );
};

export default PageTransition;